// extracted by mini-css-extract-plugin
export default {"input":"smhFFfnYW4Y1FcRhBWTO","submit":"ypXK6lsKtRTkwCkDeyo6","block":"s6poIwdyUWCDRLglbKuA","eye":"kt22nFiZmA2N8GGp1FAl"};